import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow, CCol,
	CContainer,
	CForm, CFormInput, CInputGroup, CInputGroupText, CFormSelect,
	CButton, CImage,
	CLink,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { MyButton } from '../components/index'
import { UFunc } from '../helpers/functions'
import { isMobile } from "react-device-detect";
import useSatusehat from '../helpers/useSatusehat'

const pjson = require('../../package.json');
const Login = (props) => {
	const { 
		setToken,setLoading, showToast 
	} = props; 

	//console.log("Login - props => "+JSON.stringify(props));
	const { getToken } 	= useSatusehat(props);
	const uNavigate  		= useNavigate();
	const uDispatch			= useDispatch();

	const uBahasaob  		= useSelector(state => state.listBahasa);
	const uRouteProfileArr	= useSelector(state => state.profileRoute); 
	const uEfekapp			= useSelector(state => state.effectApp);
	const uConfigappsObj	= useSelector(state => state.uConfigappsObj) || {}; 
	const uCabangattrArr 	= useSelector(state => state.gCabangatribut) || {};
	const uTokenObj			= JSON.parse(localStorage.getItem("token"));

	const uDatacabangArr	= JSON.parse(localStorage.getItem("cabanglist") || "[]");
	const [uInpUsername,setUsername]  		= React.useState(localStorage.getItem("lastusername") || "");
	const [uInpPasswd,setInpPasswd]   		= React.useState('');
	const [uISShowpasswd,setShowpasswd]   	= React.useState(false);
	const [uInpCabangID,setInpCabangID]   	= React.useState(localStorage.getItem("lastcabangid") || "0");
	const [uBtnDisabled,setBtnDisabled]		= React.useState(true);
	const [uTokentmpstorage,setTokentmpstorage]= React.useState("");
	const [uISAuthsatusehat,setAuthsatusehat]= React.useState(false);
	const [uErrorlocation,setErrorlocation]		= React.useState();

	const uISShowtoggle						= (uInpPasswd||"").trim() !== "" && isMobile;

	const initBrandname	= () =>{
		const vNameArr = pjson.name.split("esystem");
		return (
			<>
			<CImage src="/images/icon_logo_t.png" height={45} className="align-bottom d-md-none"/>
			<span className="classfontbrand">
				NARA E
			</span>
			<small className="classfontfedoka classfontcolormain">system</small>
			<small className="me-1"/>
			<small>v{pjson.version}</small>
			</>
		)
	}

	const hdlKlikLogin = () => {
		//---VALIDASI--/
		if(parseInt(uInpCabangID) <= 0 || uInpUsername.trim() === "" || uInpPasswd === "") return;
		//---END VALIDASI--/

		//apiProseslogin();

		//--GEOLOCATION_DULU--/
		if (navigator.geolocation) {
			setLoading(true);
			setBtnDisabled(true);
			navigator.geolocation.getCurrentPosition((position) => {
				setLoading(false);
				setBtnDisabled(false);
				const watchID = navigator.geolocation.watchPosition(()=>{}, ()=>{});

				const vTmpObj = {
					latitude: position.coords.latitude,
					longitude: position.coords.longitude,  
					watchID: watchID,
				}
				apiProseslogin(JSON.stringify(vTmpObj));
			},
			// Error callback: sets an error message based on the error code
			(err) => {
				setLoading(false);
				setBtnDisabled(false);

				let vErrortmp;
				switch (err.code) {
					case err.PERMISSION_DENIED:
						vErrortmp	= ('User denied the request for Geolocation.');
						break;
					case err.POSITION_UNAVAILABLE:
						vErrortmp	= ('Location information is unavailable.');
						break;
					case err.TIMEOUT:
						vErrortmp	= ('The request to get user location timed out.');
						break;
					case err.UNKNOWN_ERROR:
						vErrortmp	= ('An unknown error occurred.');
						break;
					default:
						vErrortmp	= ('An unexpected error occurred.');
				}
				// Log the error message for better debugging, or the error object if message is not available
				console.error("Geolocation Error:", err.message || err);
				setErrorlocation("NOTE Lokasi: "+vErrortmp);
				apiProseslogin();
			},
			// Options for getCurrentPosition
			{
				enableHighAccuracy: true, // Request the most accurate position possible
				timeout: 5000,            // Maximum time (ms) to wait for a position
				maximumAge: 0             // Don't use a cached position
			});
		} else {
			// Browser does not support Geolocation
			//localStorage.removeItem("geolocation_str");
			//showToast('Geolocation is not supported by your browser.');
			setErrorlocation("NOTE Lokasi: Geolocation is not supported by your browser.");

			apiProseslogin();
		}
		//--END GEOLOCATION_DULU--/
	}

	const apiProseslogin = (_GEOLOCATIONSTR) => {
		const vGeolocationObj = JSON.parse(_GEOLOCATIONSTR || "{}"); 

		setLoading(true);
		setBtnDisabled(true);

		/*//--TEST_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return;
		//--END TEST_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_cabangid : uInpCabangID,
			send_username : uInpUsername,
			send_passwd : uInpPasswd,
			send_geolocation: JSON.stringify(vGeolocationObj),
		});
		const vURLs	= pjson.homepage+"api2/api_login/pr_login";
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		})
		.then((response)=> {
			if (response.status === 200) return response.json();
		})
		.then((output_string) => {
			setLoading(false);
			setBtnDisabled(false);

			//console.log("(Login - apiProseslogin) output_string.langs : ",output_string.langs);
			uDispatch({type: "set", listBahasa: JSON.parse(output_string.langs || "{}")});

			if(output_string.sukses) {
				setBtnDisabled(true);
				
				uDispatch({type: "set", gSystemsetting:JSON.parse(output_string.systemsetting||"{}")});
				uDispatch({type: "set", listNav: JSON.parse(output_string.nav||"[]")});

				if(output_string.routes) {
					const vRouteLoadArr = JSON.parse(output_string.routes||"[]");
					const vNewRoutes	= [...uRouteProfileArr,...vRouteLoadArr];

					localStorage.setItem("routeslist", JSON.stringify(vNewRoutes));
					
					uDispatch({type: "set", gRouteISrefresh: true});
				}//-*/

				const vCabangattributObj = JSON.parse(output_string.cabangatribut || "{}");
				uDispatch({type: "set", gCabangatribut: vCabangattributObj});

				localStorage.setItem("lastusername",(uInpUsername||"").trim());
				localStorage.setItem("lastcabangid",uInpCabangID);
				localStorage.setItem("cabanglist", output_string.cabanglist||""); 

				uDispatch({type: "set", geolocation_str: JSON.stringify(vGeolocationObj)});
						
				setTokentmpstorage(output_string.token||"{}");

				if(uInpUsername.trim() === uInpPasswd) {
					showToast("<p><b>PERINGATAN KEAMANAN</b>:</p>"+
						"<p class='fst-italic'>USERNAME dan PASSWORD Anda Terdeteksi <b>TIDAK AMAN</b>."+
						" Mohon Ganti Password Atau Username Anda!</p>"+
						"<p>Kondisi Tersebut Membuat DATA Rentan Terhadap <b>Serangan Hacker</b>.</p>"+
					"","ERROR");
				}

				if((vCabangattributObj.satusehat_clientkey || "")===""
					|| (vCabangattributObj.satusehat_secretkey || "")===""
					) {
					if(uErrorlocation) {
						showToast(uErrorlocation);
						setErrorlocation();
					}
					setToken(JSON.parse(output_string.token||"{}"));

					return;
				}

				setAuthsatusehat(true);
			} else {
				vGeolocationObj.watchID && (navigator.geolocation.clearWatch(vGeolocationObj.watchID));
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Login - apiProseslogin) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
				}
			}
		})
		.catch((error) =>{
			vGeolocationObj.watchID && (navigator.geolocation.clearWatch(vGeolocationObj.watchID));
			setBtnDisabled(false);
			setLoading(false);
			console.log("(Login - apiProseslogin) catch-error: "+error);
			uNavigate("/error500");
		});
	}

	React.useEffect(() => {
		if(uTokenObj) {
	    	window.location.assign("/dashboard"); return;
		}
	})
	React.useEffect(() => {
		document.getElementById("idlogowatermark") && (
			document.getElementById("idlogowatermark").style.display = "none"
		)//-*/

		let vElfocus = document.getElementById("inpusername")
		if(uInpUsername.trim() !== "")
			vElfocus = document.getElementById("inppasswd")

		if(!isMobile) vElfocus && vElfocus.focus()

		return ()=>{
			setShowpasswd(false);

			document.getElementById("idlogowatermark") && (
				document.getElementById("idlogowatermark").style.display = "block"
			)
			setInpPasswd("");
		}
	},[])
	React.useEffect(() => {
		setBtnDisabled(true);

		if(parseInt(uInpCabangID) > 0 
			&& uInpUsername.trim() !== "" 
			&& uInpPasswd !== "") setBtnDisabled(false);
	},[uInpCabangID,uInpUsername,uInpPasswd])
	React.useEffect(() => {
		if(uDatacabangArr.length === 1)
			if(parseInt(uInpCabangID) <= 0) {
				setInpCabangID(uDatacabangArr[0].id);
			}
	},[uDatacabangArr, uDatacabangArr.length])
	React.useEffect(() => {
		if(!uISAuthsatusehat) return;

		const vNextfunction = () => {
			setBtnDisabled(false);
			setToken(JSON.parse(uTokentmpstorage));
		}

		if(uErrorlocation) {
			showToast(uErrorlocation);
			setErrorlocation();
		}

		setBtnDisabled(true);
		getToken(vNextfunction);
		setTokentmpstorage(""); setAuthsatusehat(false);
	},[uISAuthsatusehat])

	//console.log("(Login) uConfigappsObj => "+JSON.stringify(uConfigappsObj))
	return (
		<>
		{(isMobile) && (
		<style>{`
			input#inppasswd::-ms-reveal,
			input#inppasswd::-ms-clear {
				display: none;
			}
		`}</style>
		)}
		<div className="classbglogintop" style={{
			backgroundImage:"url(images/bg_gradient_bottom.png)"
			}}/>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
			<div className="body flex-grow-1 px-3 d-flex align-items-center">
			<CRow className="justify-content-center w-100 mx-auto">
			<CCol md="3" xs="11" className="d-none d-md-flex flex-row justify-content-center align-items-center">
				<div className="text-center">
				<CImage src="images/logo192.png" className="m-auto" height={185}/>
				<div className="mt-2 mx-auto classfontfedoka classfontcolorbrand">
				{(uConfigappsObj.level_app||"").toUpperCase() === "PRO" ? (
					<>&middot; {uConfigappsObj.branch_kode} &middot;</>
				) : (
					<>&middot; {uConfigappsObj.opening_name} &middot;</>
				)}
				</div>
				</div>
			</CCol>
			<CCol md="1" lg="0" className="px-0 border-end"/>
			<CCol md="5" xs="11" className="px-sm-2 px-lg-5 text-center">
				<div className="" style={{paddingBottom:"-9px Important"}}>
				{initBrandname()}
				</div>
				<div className="classfontsmaller">
				{UFunc.renderHTML(uBahasaob.petunjuk_login || "Silahkan Login untuk Masuk dan<br />Menggunakan Aplikasi Ini")}
				</div>

			<CForm className="px-md-4 px-lg-5">
				<CInputGroup className={"my-2"+(uDatacabangArr.length <= 1 ? " d-none" : "")}>
					<CInputGroupText>
					<CIcon icon="cilBuilding" className="text-primary"/>
					</CInputGroupText>
					<CFormSelect 
						onChange={(e)=>setInpCabangID(e.target.value)} 
						value={uInpCabangID}
						className="bg-white"
						id="inpcabangid">
					<option value="0">--PILIH CABANG</option>
					{uDatacabangArr.map((vItems,vKeys)=>{
						return (
						<option key={vKeys} value={vItems.id}>{(vItems.cabang_nama||"UNDF").toUpperCase()}</option>
						)
					})}
					</CFormSelect> 
				</CInputGroup>

				<CInputGroup className="my-2">
					<CInputGroupText>
					<CIcon icon="cilUser" className="text-primary"/>
					</CInputGroupText>
					<CFormInput type="text" 
						onChange={(e)=>setUsername(e.target.value)} 
						placeholder={(uBahasaob.word_username||"Username")+".."} 
						autoComplete="off" 
						value={uInpUsername}
						id="inpusername"
						className="bg-white"
						required/>
				</CInputGroup>

				<CInputGroup className="my-2">
					<CInputGroupText>
					<CIcon icon="cilLockLocked" className="text-primary"/>
					</CInputGroupText>

					<CFormInput type={uISShowpasswd ? "text" : "password"} 
						onChange={(e)=>{setInpPasswd(e.target.value);}} 
						placeholder={(uBahasaob.word_passwd||"Password")+".."} 
						className={(uISShowtoggle ? "border-end-0 " : "")+(uISShowpasswd ? "text-muted fst-italic" : "")}
						autoComplete="current-password off" required
						value={uInpPasswd}
						id="inppasswd"/>

					{(uISShowtoggle) && (
					<CInputGroupText className="border-secondary border-start-0 bg-white">
					<CLink onClick={()=>setShowpasswd(!uISShowpasswd)} className="text-black">
						{(!uISShowpasswd) ? (
							<FaRegEye/>
						) : (
							<FaRegEyeSlash/>
						)}
					</CLink>
					</CInputGroupText>
					)}
				</CInputGroup>

				<CInputGroup className="my-2 my-md-4">
				<MyButton
					iconname="cilLockUnlocked"
					onClick={()=>hdlKlikLogin()}
					disabled={uBtnDisabled}
					id="btnLogin">L o g i n</MyButton>
				</CInputGroup>
				<div className="text-center">
					<p className="classpetunjuk">
					{uBahasaob.caption_lupapasswd||"Lupa Password"}?{" "}
					<strong className="text-dark">{uBahasaob.caption_hubsupervisor||"Hubungi Supervisor"}</strong>
					</p>
				</div>
			</CForm>
			</CCol>
			</CRow>
			</div>
		</div>	
		</>
	)//>
}

export default Login